import ManageOrgTags from './ManageOrgTags.container';

export default ManageOrgTags;
